module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_mypage-2c67d1f4b68a3b910d66bf7ff561daff.png";